module.exports = __webpack_public_path__ + "img/system-open-account.2eb1fc93.svg";